import {
  TableContainer,
  Paper,
  TableHead,
  useTheme,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Typography,
  Box,
} from "@mui/material";
import { User } from "components/authentication/models/authTypes";
import { logAmplitudeEventWithProps } from "components/common/amplitude/amplitude";
import packageJson from "../../../../../../package.json";
import localStorageHelper from "../../../../../app/localStorage";
import { useState } from "react";
const SegmentItemlist = ({ invoiceDetails }) => {
  const [user] = useState<User | undefined>(
    localStorageHelper.getByKey("user")
  );
  logAmplitudeEventWithProps(
    user.userNameAndCompany,
    {
      company: user.company,
      user: user.userName,
    },
    "segmentItemDetailsLoad",
    {
      elapsed_ms: "124",
      title: "Segment Item List",
      componentName: "segment-item-list.tsx",
      version: packageJson.version,
    }
  );

  const theme = useTheme();

  const getItemTypeDisplay = (type: string) => {
    switch (type?.toUpperCase()) {
      case "PA":
        return "Part";
      case "MC":
        return "Misc Charge";
      case "UN":
        return "Unit";
      case "TR":
        return "Trade In";
      case "RE":
        return "Remark";
      case "SL":
        return "Segment Labor";
      case "RU":
        return "Rental Unit";
      case "QU":
        return "Quoted Unit";
      default:
        return type;
    }
  };

  return (
    <Box sx={{ width: "100%", overflowX: "auto" }}>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: theme.shadows[10],
          minWidth: 600,
        }}
      >
        <Table sx={{ minWidth: 650 }}>
          <TableHead
            sx={{
              backgroundColor: theme.palette.primary.main,
              "& .MuiTableCell-head": {
                backgroundColor:
                  theme.palette.mode === "light"
                    ? "#2371E7"
                    : "rgba(0, 0, 0, 0.5)", //theme.palette.primary.main, // Ensure cells inherit the TableHead background
                color:
                  theme.palette.mode === "light"
                    ? theme.palette.primary.contrastText
                    : "white", // Adjust text color for contrast
              },
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  color: theme.palette.primary.contrastText,
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Item Type
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  color: theme.palette.primary.contrastText,
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Display Text
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  color: theme.palette.primary.contrastText,
                  fontWeight: 500,
                  fontSize: "14px",
                }}
              >
                Description
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoiceDetails.map((item, index) => (
              <TableRow
                key={item.itemIdentity}
                sx={{
                  backgroundColor:
                    index % 2 === 0
                      ? theme.palette.mode === "dark"
                        ? "rgba(255, 255, 255, 0.02)"
                        : "rgba(0, 0, 0, 0.02)"
                      : theme.palette.background.paper,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    backgroundColor: theme.palette.action.hover,
                    transform: "scale(1.01)",
                    boxShadow: `inset 0 0 0 2px ${theme.palette.primary.light}`,
                  },
                }}
              >
                {/* sx={{ py: 3 }} */}
                <TableCell>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, fontSize: 13 }}
                  >
                    {getItemTypeDisplay(item.segmentItemType)}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, fontSize: 13 }}
                  >
                    {item.segmentDisplayText}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 500, fontSize: 13 }}
                  >
                    {item.segmentDescription}
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SegmentItemlist;
